import styles from './Alert.module.scss'
import React from 'react'
import cl from 'classnames'

export const Alert = ({ title, text, icon, height100 = false }) => {
	return (
		<div className={cl(styles.information, { [styles.heightFixed]: height100 })}>
			<div className={styles.hintIcon}>{icon}</div>
			<div className={styles.textContainer}>
				<div className={cl(styles.title, styles.text)}>{title}</div>
				{text && <div className={cl(styles.label, styles.text)}>{text}</div>}
			</div>
		</div>
	)
}
